import { ExtendedMetadataAttributeConfigReadExternal } from '@askporter/client-grieg-lyric';

/**
 * Returns the `displayName` of the attribute matching `jsonElementName` from a
 * group's attribute list, or `undefined` if the attribute is not present.
 */
export const getAttributeDisplayName = (
  attributes: ExtendedMetadataAttributeConfigReadExternal[] | undefined,
  jsonElementName: string,
): string | undefined => attributes?.find((attribute) => attribute.jsonElementName === jsonElementName)?.displayName;
